var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-view',[_c('contact-section',{attrs:{"heading":_vm.$t('contact')}}),_vm._v(" "),_c('map-section',{attrs:{"heading":_vm.$t('mapHeading')}}),_vm._v(" "),_c('links-section',{attrs:{"heading":_vm.$t('linksHeading'),"links":_vm.links.items}}),_vm._v(" "),_c('job-offers-section',{attrs:{"heading":_vm.$t('jobHeading'),"description":_vm.jobDescription,"offers":_vm.jobs}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d6fdec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Contact/ContactContainer.vue
// module id = null
// module chunks = 